import styled from 'styled-components';

export const SliderWrapper = styled.div`
  margin: 0 25px;

  .slick-prev:before,
  .slick-next:before {
    color: #000;
  }

  .slick-prev.slick-disabled:before {
    opacity: 1;
  }
`;

export const StyledArrow = styled.div`
  &.slick-prev,
  &.slick-next {
    width: 50px;
    height: 50px;
    z-index: 10;
    top: 100px;
  }

  &.slick-prev:before,
  &.slick-next:before {
    font-size: 50px;
  }

  span {
    @media (max-width: 767px) {
      display: none;
    }

    display: initial;
    font-size: 18px;
    color: #000;
    position: absolute;
    top: 20px;
    text-align: left;
    margin-left: 10px;
    width: 170px;
    text-align: left;
    font-weight: bold;
    font-family: 'Vodafone', sans-serif;
    color: #333333;

    &.label-next {
      right: 0px;
    }

    &.label-prev {
      left: 52px;
    }
  }
`;
